import { HttpContext, HttpContextToken } from '@angular/common/http';

/**
 * Marks a request as BACKGROUND: it must not raise the global loading overlay.
 *
 * The overlay is a full-screen blocking curtain, and that is right for a request
 * the reader is waiting on — opening a page, saving a form. It is wrong for a
 * request the reader is not waiting on because the UI already answered them: an
 * optimistic like has drawn its filled heart before the POST leaves, so freezing
 * the whole application until the server agrees would undo the very thing the
 * optimistic update bought.
 *
 * Opt-in, never a default: a request is silent only when it says so, so nothing
 * loses its loading state by accident.
 */
export const SKIP_GLOBAL_LOADING = new HttpContextToken<boolean>(() => false);

/** Ready-made context for a background request. */
export function silentRequestContext(): HttpContext {
  return new HttpContext().set(SKIP_GLOBAL_LOADING, true);
}
